"use client";

import { useEffect, useRef } from "react";

import { isConsentToAll } from "../../tcf/helpers";
import { getIdentitySession } from "../../utils/auth/getSessionFromIdentity";
import { getGeoTrackingPermission } from "../Ad/utils/helpers/getGeoTrackingPermission";

// Preloads external data used by ads (consent, session, geo tracking) on mount.
const AdDataPreloader = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  const hasPreloaded = useRef(false);

  useEffect(() => {
    if (hasPreloaded.current) {
      return;
    }

    hasPreloaded.current = true;
    (async () => {
      try {
        const [_, { sig, userId }] = await Promise.all([
          isConsentToAll(),
          getIdentitySession(isLoggedIn),
        ]);

        await getGeoTrackingPermission(isLoggedIn, userId, sig);
      } catch (error) {
        console.warn("Data preload failed:", error);
      }
    })();
  }, [isLoggedIn]);

  return null;
};

export { AdDataPreloader };
